(() => {
  'use strict';

  if (window.__foodnetP0Stability) return;
  window.__foodnetP0Stability = true;

  let resizeObserver = null;
  let drawerQuantityBusy = false;

  const rootPath = () => {
    const root = window.Shopify?.routes?.root || '/';
    return root.endsWith('/') ? root : `${root}/`;
  };
  const route = (path) => `${rootPath()}${String(path).replace(/^\//, '')}`;

  const headerHost = () => document.querySelector('.wk-hdr-sticky-host')
    || document.querySelector('.shopify-section-group-header-group')
    || document.querySelector('[data-site-header]');

  const syncHeaderHeight = () => {
    const header = headerHost();
    if (!header) return;
    const height = Math.max(0, Math.ceil(header.getBoundingClientRect().height));
    if (height > 0) {
      document.documentElement.style.setProperty('--foodnet-sticky-header-height', `${height}px`);
    }
  };

  const observeHeader = () => {
    const header = headerHost();
    syncHeaderHeight();
    if (!header || typeof ResizeObserver !== 'function') return;
    resizeObserver?.disconnect();
    resizeObserver = new ResizeObserver(syncHeaderHeight);
    resizeObserver.observe(header);
  };

  const syncHeaderCart = (cart) => {
    document.querySelectorAll('[data-cart-count]').forEach((count) => {
      count.textContent = String(cart?.item_count || 0);
      count.hidden = !cart?.item_count;
    });
  };

  const refreshCartDrawerMarkup = async () => {
    const current = document.querySelector('[data-cart-drawer]');
    if (!current) return;

    const response = await fetch(`${rootPath()}?sections=cart-drawer`, {
      credentials: 'same-origin',
      headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      cache: 'no-store'
    });
    if (!response.ok) throw new Error('Winkelwagenweergave kon niet worden vernieuwd.');

    const sections = await response.json();
    const html = sections?.['cart-drawer'];
    if (!html) throw new Error('Winkelwagenweergave ontbreekt.');

    const parsed = new DOMParser().parseFromString(html, 'text/html');
    const fresh = parsed.querySelector('[data-cart-drawer]');
    if (!fresh) throw new Error('Nieuwe winkelwagenweergave ontbreekt.');

    // Preserve the live drawer element so WOKORA v11 keeps the same reference
    // for close controls, overlay handling and focus trapping.
    current.innerHTML = fresh.innerHTML;
  };

  const setDrawerControlsBusy = (drawer, busy) => {
    if (!drawer) return;
    drawer.setAttribute('aria-busy', busy ? 'true' : 'false');
    drawer.querySelectorAll('[data-cart-line-qty], [data-qty-minus], [data-qty-plus], [data-remove-line]').forEach((control) => {
      control.disabled = busy;
    });
  };

  const updateDrawerQuantity = async (input) => {
    if (drawerQuantityBusy || !input?.isConnected) return;

    const drawer = input.closest('[data-cart-drawer]');
    const line = Number(input.dataset.cartLineQty || 0);
    const quantity = Math.max(1, Number.parseInt(input.value, 10) || 1);
    if (!drawer || !line) return;

    input.value = String(quantity);
    drawerQuantityBusy = true;
    setDrawerControlsBusy(drawer, true);

    try {
      const response = await fetch(route('cart/change.js'), {
        method: 'POST',
        credentials: 'same-origin',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        },
        body: JSON.stringify({ line, quantity })
      });
      const cart = await response.json().catch(() => ({}));
      if (!response.ok) {
        throw new Error(cart?.description || cart?.message || 'Aantal kon niet worden aangepast.');
      }

      syncHeaderCart(cart);
      await refreshCartDrawerMarkup();
      document.dispatchEvent(new CustomEvent('wokora:cart-updated', {
        detail: { cart, source: 'foodnet-cart-drawer-quantity' }
      }));
    } catch (error) {
      console.warn('FoodNet cart drawer quantity update failed', error);
      try {
        await refreshCartDrawerMarkup();
      } catch (_) {
        window.location.reload();
        return;
      }
    } finally {
      drawerQuantityBusy = false;
      const activeDrawer = document.querySelector('[data-cart-drawer]');
      setDrawerControlsBusy(activeDrawer, false);
    }
  };

  document.addEventListener('change', (event) => {
    const input = event.target.closest?.('[data-cart-line-qty]');
    if (!input) return;
    updateDrawerQuantity(input);
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', observeHeader, { once: true });
  } else {
    observeHeader();
  }

  window.addEventListener('resize', syncHeaderHeight, { passive: true });
  window.addEventListener('pageshow', syncHeaderHeight);
  document.addEventListener('shopify:section:load', observeHeader);
})();
